import React from 'react';
import { Column } from 'react-virtualized';
import { useIntl } from 'react-intl';
import TableStyles from 'styles/table.css';
import {
  PATIENT_TABLE_COLUMN_HEADERS,
  TABLE_COLUMN_HEADER_WIDTH,
  TABLE_HEADER_HEIGHT_NO_FILTERS,
  TABLE_ROW_HEIGHT,
} from '../Table/utils';
import { DefaultRowRenderer } from '../Table/RowRenderers';
import {
  billingCodeCellRenderer,
  connectionPlanCellRenderer,
  connectionStatusCellRenderer,
  dobCellRenderer,
  orderingProviderCellRenderer,
  patientCellRenderer,
} from '../Table/CellRenderers';
import PagingTable from '../Table/PagingTable';

const SearchResultsTable = ({
  styles,
  noDataText = 'No patients found.',
  isLoading,
  onRowClick,
  sortBy,
  sortDirection,
  scrollToIndex,
  loadingPage,
  onScroll,
  onRowsRendered,
  rows,
  error,
  headerRenderer,
  me,
}) => {
  const intl = useIntl();
  return (
    <PagingTable
      wrapperClassName={styles.patientSearchResultsTableWrapper}
      noDataText={noDataText}
      enableLoader
      showLoader={isLoading}
      headerHeight={TABLE_HEADER_HEIGHT_NO_FILTERS}
      rowHeight={TABLE_ROW_HEIGHT}
      onRowClick={onRowClick}
      rowRenderer={DefaultRowRenderer}
      error={error}
      rows={rows}
      sortBy={sortBy}
      sortDirection={sortDirection}
      onRowsRendered={onRowsRendered}
      scrollToIndex={scrollToIndex}
      scrollToAlignment="start"
      onScroll={onScroll}
      loadingPage={loadingPage}
      me={me}
    >
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.PATIENT}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.Patients',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.PATIENT} // not needed but field required by library
        headerRenderer={headerRenderer}
        cellRenderer={patientCellRenderer}
      />
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.DOB}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.DOB',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.DOB}
        headerRenderer={headerRenderer}
        cellRenderer={dobCellRenderer}
      />
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.ORDERING_PHYSICIAN}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.Providers',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN}
        headerRenderer={headerRenderer}
        cellRenderer={orderingProviderCellRenderer}
      />
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.CONNECTION_STATUS}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.Connections',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.CONNECTION_STATUS}
        headerRenderer={headerRenderer}
        cellRenderer={connectionStatusCellRenderer}
      />
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.PRESCRIPTION}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.Prescriptions',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.PRESCRIPTION}
        headerRenderer={headerRenderer}
        cellRenderer={connectionPlanCellRenderer}
      />
      <Column
        width={TABLE_COLUMN_HEADER_WIDTH.BILLING_CODE}
        className={TableStyles.column}
        label={intl.formatMessage({
          id: 'search.SearchResults.TableHeader.BillingCode',
        })}
        dataKey={PATIENT_TABLE_COLUMN_HEADERS.BILLING_CODE}
        headerRenderer={headerRenderer}
        cellRenderer={billingCodeCellRenderer}
      />
    </PagingTable>
  );
};
export default SearchResultsTable;



// WEBPACK FOOTER //
// ./src/views/components/Search/SearchResultsTable.jsx